// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IChatsRequest,
  TChatsModel,
  IMappers,
  TChatsResponse,
  IChatsResponse,
  IChatsResponseError,
} from './types';

export const defaultConfig: TChatsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/chats/',
} as TChatsModel;

export function createChatsModel(parameters: IChatsRequest): TChatsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IChatsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IChatsRequest;
}

export async function fetchChats<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChatsOptions<TResponse200, TResponse400>): Promise<TChatsResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createChatsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IChatsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IChatsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TChatsResponse;
}
